<template>
  <div class="drawer" v-if="!hasShown && isMobile">
    <span class="drawer__icon">
      <img src="../assets/app_icon_256x256px.png" alt="MELOSTOCK" class="drawer__icon__image">
    </span>

    <span class="drawer__text">Add hozzá a főképernyődhöz</span>
  </div>
</template>

<script>
  import { getCookie, setCookie } from '../utils/cookie'

  export default {
    data: () => ({
      cookieName: 'MeloStockHomeScreenDrawer',
      openDelay: 500, // in milliseconds
      closeDelay: 4000, // in milliseconds
      isOpenClass: 'is-open',
      openTimeout: null,
      closeTimeout: null
    }),

    beforeDestroy () {
      clearTimeout(this.openTimeout)
      clearTimeout(this.closeTimeout)
    },

    computed: {
      isMobile () {
        return window.innerWidth < 768
      },

      hasShown () {
        return getCookie(this.cookieName)
      }
    },

    methods: {
      init () {
        if (
          typeof getCookie(this.cookieName) === 'object' &&
          this.isMobile
        ) {
          setCookie({ cookieName: this.cookieName, value: true })

          this.openTimeout = setTimeout(this.open, this.openDelay)
          this.closeTimeout = setTimeout(this.close, this.openDelay + this.closeDelay)
        }
      },

      open () {
        if (!this.$el) {
          return
        }

        this.$el.classList.add(this.isOpenClass)
      },

      close () {
        if (!this.$el) {
          return
        }

        this.$el.classList.remove(this.isOpenClass)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// HomeScreenDrawer.vue?f21ca1ca